import React from 'react';
import {Col, Container, Row, Card, CardBody, Button, ButtonGroup} from 'reactstrap';
import {connect} from 'react-redux';
import ReactQueryParams from 'react-query-params';
import {withRouter} from 'react-router-dom';
import MaterialTable from '../../../components/table/material_table/MaterialTable'
import * as TextManager from "../../../modules/languages/TextManager";

export class SalesStatsMatTable extends ReactQueryParams {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
    }

    getMetaForStoreTable = (obj) => {

        let res = {name: "", metrics: []};

        let filterNames = obj ? Object.getOwnPropertyNames(obj) : [];

        for (let indx in filterNames) {
            let col = filterNames[indx];

            if (col !== "id_n") {

                let label = TextManager.getCurrentTextResource().SalesStat[col];
                res.metrics.push({
                    id: col,
                    label: label,
                    numeric: false,
                    disablePadding: true
                })
            }
        }
        res.metrics.reverse();
        return res;
    };


    render() {

        return (
            <Container className='dashboard'>

                <span>
                    <Row>
                        <Col md={12}>
                            <MaterialTable data={this.props.data} noPaddingCard
                                           meta={this.getMetaForStoreTable(this.props.data[0])}/>
                        </Col>
                    </Row>
                </span>

            </Container>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        status: state.salesStats.status,
        //data: state.salesStats.data,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(SalesStatsMatTable))